<template>
  <div class="animated fadeIn">
    <basic-heading title="Samples">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list sample'">
      <template #gated-content>
        <b-row class="px-0 m-0 bg-light my-3">
          <b-col
            v-for="(indicator, index) in indicators"
            :key="index"
            :class="`px-${index === 1 ? 3 : 0}`"
          >
            <indicator-tile
              :text="indicator.text"
              :indicator_key="indicator.indicator_key"
              :faIcon="indicator.faIcon"
              :variant="indicator.variant"
            />
          </b-col>
        </b-row>
        <sample-server-table
          @deleteSample="deleteSample"
          @markSent="markSent"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import IndicatorTile from "@/components/shared/IndicatorTile";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import SampleServerTable from "@/components/lab/sample/SampleServerTable";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { sample_indicators } from "@/shared/_indicators";

const SampleRepository = LabRepositoryFactory.get("sample");

export default {
  name: "SampleIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    IndicatorTile,
    PermissionAlertGate,
    SampleServerTable,
  },
  data() {
    return {
      indicators: sample_indicators,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    deleteSample(id) {
      new Promise((resolve, reject) => {
        SampleRepository.suspend(id)
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
      })
        .then(() => {
          for (let index in this.samples) {
            let sample = this.samples[index];
            if (sample && sample.id && sample.id === id) {
              this.samples.splice(index, 1);
            }
          }
          this.deleteSuccess();
        })
        .catch(() => {
          this.deleteFail();
        });
    },
    markSent(id) {
      new Promise((resolve, reject) => {
        SampleRepository.updateStatus(id, "Sent")
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
      }).then((response) => {
        for (let index in this.samples) {
          let sample = this.samples[index];
          if (sample && sample.id && sample.id === id) {
            this.samples.splice(index, 1, response.data);
          }
        }
      });
    },
  },
};
</script>
